// eslint-disable-next-line import/named
import { linkColors, nodeColorsRegion, nodeColorsSrcDst } from '../config';

export const sourceType = {
	src: 'src',
	dst: 'dst',
};

// 取得 node id
export const getNodeId = (type, ele) => {
	let id = '';
	if (type === sourceType.src) {
		id = ele.srcId;
	}
	if (type === sourceType.dst) {
		id = ele.dstId;
	}
	return id;
};

// 取得 node label
export const getNodeLabel = (type, ele) => {
	let source = '';
	if (type === sourceType.src) {
		source = ele.srcName;
		source += ele.srcStartDate ? `(${ele.srcStartDate})` : '';
	}
	if (type === sourceType.dst) {
		source = ele.dstName;
		source += ele.dstStartDate ? `(${ele.dstStartDate})` : '';
	}
	return source;
};

// generate sna data
export const genSnaData = (dbData) => {
	const defaultReturn = {
		links: [],
		nodes: [],
	};

	if (dbData.length === 0) return defaultReturn;
	const nodesDst = []; // 找出所有destination node
	const nodesSrc = []; // 找出所有source node

	// 依據 property (region) 取得 node color
	const getNodeColor = (type, ele) => {
		let color = nodeColorsRegion.default;
		let region;
		// let country;
		let regionStr = '';
		if (type === sourceType.src) {
			region = ele.srcLocRegion;
			// country = node.src_country;
		}
		if (type === sourceType.dst) {
			region = ele.dstLocRegion;
			// country = node.dst_country;
		}
		if (region) {
			regionStr = region.replace(' ', '').toLowerCase();
			if (regionStr in nodeColorsRegion) {
				color = nodeColorsRegion[regionStr];
			}
		}
		return color;
	};

	const links = [];
	//
	dbData.forEach((element) => {
		// element keys:
		// srcId ,srcName ,srcStartDate ,srcEndDate ,
		// srcLocId ,srcLocLabel ,srcLocCountry ,srcLocRegion
		// dstId ,dstName ,dstStartDate ,dstEndDate ,
		// dstLocId ,dstLocLabel ,dstLocCountry ,dstLocRegion
		const findDstNode = nodesDst.find((node) => node.nodeId === element.dstId);
		if (!findDstNode) {
			nodesDst.push({
				id: getNodeId(sourceType.dst, element), // id 是 uniq id
				label: getNodeLabel(sourceType.dst, element), // label 是用來顯示 node 的名稱
				// source: getNodeLabel(sourceType.dst, element),
				color: nodeColorsSrcDst.dst,
				// color: getNodeColor(sourceType.dst, element),
				symbolType: 'circle',
				nodeId: element.dstId,
				locCountry: element.dstLocCountry,
				locRegion: element.dstLocRegion,
			});
		}
		const findSrcNode = nodesSrc.find((node) => node.nodeId === element.srcId);
		if (!findSrcNode) {
			nodesSrc.push({
				id: getNodeId(sourceType.src, element), // id 是 uniq id
				label: getNodeLabel(sourceType.src, element), // label 是用來顯示 node 的名稱
				// source: getNodeLabel(sourceType.src, element),
				color: nodeColorsSrcDst.src,
				// color: getNodeColor(sourceType.src, element),
				symbolType: 'circle',
				nodeId: element.srcId,
				locCountry: element.srcLocCountry,
				locRegion: element.srcLocRegion,
			});
		}
		links.push({
			source: getNodeId(sourceType.src, element), // 對應到 id
			target: getNodeId(sourceType.dst, element), // 對應到 id
			label: `${element.srcName}-${element.dstName}`,
		});
	});

	// 如果是source node也是target node，顏色改成target node顏色
	const nodesSrcCorrect = nodesSrc.map((element) => {
		const checkDstNode = nodesDst.find((node) => node.nodeId === element.nodeId);
		if (checkDstNode) {
			return { ...element, color: nodeColorsSrcDst.dst };
		}
		return element;
	});

	const allNodes = [...nodesDst, ...nodesSrcCorrect];

	return { links, nodes: allNodes };
};

// get legend for graph
export const getLegend = (nodes, legendKey = 'locRegion') => {
	if (!Array.isArray(nodes)) return null;

	const regions = nodes.reduce((acc, cur) => {
		if (cur[legendKey] && !acc.includes(cur[legendKey])) {
			acc.push(cur[legendKey].replace(' ', '').toLowerCase());
		}
		return acc;
	}, []);
	return regions.reduce((acc, cur) => {
		if (cur in nodeColorsRegion) {
			acc[cur] = nodeColorsRegion[cur];
		}
		return acc;
	}, {});
};

// 改變 node 的顏色
export const changeNodeColor = (nodeId, color) => {
	if (!nodeId && color) return;
	const bindIds = Array.isArray(nodeId) ? nodeId : [nodeId];
	bindIds.forEach((bindId) => {
		const ele = document.getElementById(bindId);
		if (ele) {
			const path = ele.querySelector('path');
			if (path) {
				path.setAttribute('fill', color);
			}
		}
	});
};

// 還原所有 nodes 的 color
export const recoveryNodeColor = async (nodes) => {
	try {
		if (!Array.isArray(nodes)) return 'finish';
		nodes.forEach((node) => {
			const { id, color } = node;
			if (id && color) {
				changeNodeColor(id, color);
			}
		});
		return 'finish';
	} catch (err) {
		return 'finish';
	}
};

// 變更 link 的顏色
export const changeLinkColor = (linkId, color) => {
	const bindIds = Array.isArray(linkId) ? linkId : [linkId];
	bindIds.forEach((bindId) => {
		const ele = document.getElementById(bindId);
		if (ele) {
			const style = ele.getAttribute('style') || '';
			// console.log('style', style);
			const strokeReg = /stroke:\s?rgb\(.+\);/;
			const newStyle = `${style.replace(strokeReg, '')}stroke: ${color};`;
			// console.log('newStyle', newStyle);
			ele.setAttribute('style', newStyle);
		}
	});
};

// 還原所有 link 的顏色
export const recoveryLinkColor = async (links) => {
	try {
		if (!Array.isArray(links)) return 'finish';
		links.forEach((link) => {
			const { source, target } = link;
			if (source && target) {
				const id = `${source},${target}`;
				changeLinkColor(id, linkColors.default);
			}
		});
		return 'finish';
	} catch (err) {
		return 'finish';
	}
};

// 找出所有連結到此 node 的 link
export const findAllLinksToNode = (node, links) => {
	const { id } = node;
	if (!(id && Array.isArray(links))) return [];
	const connectLink = [];
	const restLink = [];
	const keys = ['source', 'target'];
	links.forEach((link) => {
		let find = false;
		keys.forEach((key) => {
			if (key in link && link[key] === id) {
				find = true;
			}
		});
		if (find) {
			connectLink.push(link);
		} else {
			restLink.push(link);
		}
	});
	return { connectLink, restLink };
};

// 取得某個 publication 的 cited pub 及 citing pub
export const getCitedCiting = (dbData, nodeId) => {
	//
	const getSrcId = (ele) => getNodeId(sourceType.src, ele);
	const getDstId = (ele) => getNodeId(sourceType.dst, ele);
	const getSrcLabel = (ele) => getNodeLabel(sourceType.src, ele);
	const getDstLabel = (ele) => getNodeLabel(sourceType.dst, ele);

	// 取得 publication 引用(cited)的 publication
	const pubCitedKey = 'cited';
	// tmpPubCited: {cited: ["PUB1", "PUB11"]}
	const tmpPubCited = dbData.initial
		.filter((dt) => getSrcId(dt) === nodeId)
		.reduce((acc, cur) => {
			if (!(pubCitedKey in acc)) {
				acc[pubCitedKey] = [];
			}
			// 取 node label 放進 array 中
			acc[pubCitedKey].push(getDstLabel(cur));
			return acc;
		}, {});
	// 陣列轉成字串: ["PUB1", "PUB11"]  =>  PUB1,PUB11 => 用於顯示在 data 列表中
	tmpPubCited[pubCitedKey] = (Array.isArray(tmpPubCited[pubCitedKey]) && tmpPubCited[pubCitedKey].join(',')) || '';

	// 取得 publication 被引用(citing)的 publication
	const pubCitingKey = 'citing';
	// tmpPubCiting: {cited: ["PUB1", "PUB11"]}
	const tmpPubCiting = dbData.initial
		.filter((dt) => getDstId(dt) === nodeId)
		.reduce((acc, cur) => {
			if (!(pubCitingKey in acc)) {
				acc[pubCitingKey] = [];
			}
			// 取 node label 放進 array 中
			acc[pubCitingKey].push(getSrcLabel(cur));
			return acc;
		}, {});
	// 陣列轉成字串: ["PUB1", "PUB11"]  =>  PUB1,PUB11 => 用於顯示在 data 列表中
	tmpPubCiting[pubCitingKey] =
		(Array.isArray(tmpPubCiting[pubCitingKey]) && tmpPubCiting[pubCitingKey].join(',')) || '';

	return { ...tmpPubCited, ...tmpPubCiting };
};
